import React from "react";

import styles from "./nav_bar.module.css";
import { Link } from "react-router-dom";
import MobileMenu from "../../header/mobile_menu";

const Navbar = () => {


  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.navbar_container}>
          <Link
            to="/"
            className={styles.navbar_logo_home}
          >
            JSOFTWARE
          </Link>
          <MobileMenu dark />
          <ul className={styles.nav_menu}>
            <li className={styles.nav_item}>
              <Link
                to="/company"
                className={styles.nav_links}
                  >
                회사소개
              </Link>
            </li>
            <li className={`${styles.nav_item} ${styles.menu_sub}`}>
              <Link to="/portfolio" className={styles.nav_links}>사업영역</Link>
              <ul className={styles.nav_menu_sub}>
                <li className={styles.nav_item}>
                  <Link
                    to="/portfolio"
                    className={`${styles.nav_links} ${styles.nav_links_sub}`}
                          >
                    프로젝트
                  </Link>
                </li>
                <li className={styles.nav_item}>
                  <Link
                    to="/hashtag"
                    className={`${styles.nav_links} ${styles.nav_links_sub}`}
                          >
                    해시태그
                  </Link>
                </li>
              </ul>
            </li>
            <li className={styles.nav_item}><Link to="/services" className={styles.nav_links}>서비스</Link></li>
            <li className={styles.nav_item}><Link to="/education" className={styles.nav_links}>교육·강의</Link></li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
